var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2380(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.312,
    height: 89.486,
    viewBox: "0 0 83.312 89.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380",
    transform: "translate(-414.408 -361.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68471",
    "data-name": "Path 68471",
    d: "M427.45,438.053h19.32a13.135,13.135,0,0,0-.069,1.344,13,13,0,0,0,25.991,0,13.338,13.338,0,0,0-.069-1.344h19.453l-6.9-20.763H434.445Z",
    transform: "translate(-3.797 -16.354)",
    fill: "#f0f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68473",
    "data-name": "Path 68473",
    d: "M0,0V19.288",
    transform: "translate(455.966 362.255)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379",
    transform: "translate(428.133 366.379)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4128",
    "data-name": "Line 4128",
    x1: 13.639,
    y2: 13.639,
    transform: "translate(42.028)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4129",
    "data-name": "Line 4129",
    x2: 13.639,
    y2: 13.639,
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_68472",
    "data-name": "Path 68472",
    d: "M427.63,434.046h15.411a13.132,13.132,0,0,0-.07,1.344,13,13,0,1,0,25.991,0,13.133,13.133,0,0,0-.069-1.344h27.882V462.8H415.158V434.046h0l9.793-30h62.031l9.793,30m-72.517,0h-4.327m7.7,0",
    transform: "translate(0 -12.558)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2380);
export default __webpack_public_path__ + "static/media/Group 2380.d6434600.svg";
export { ForwardRef as ReactComponent };